export type LeadTimeTone="green"|"yellow"|"red"|"purple";

function parseTimestamp(value:string){
  const normalized=/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)?`${value.replace(" ","T")}Z`:value;
  return new Date(normalized).getTime();
}

export function leadTimeDays(createdAt:string,finishedAt?:string,now=new Date()){
  const start=parseTimestamp(createdAt);
  const end=finishedAt?parseTimestamp(finishedAt):now.getTime();
  if(!Number.isFinite(start)||!Number.isFinite(end))return 0;
  return Math.max(0,Math.floor((end-start)/86_400_000));
}

export function maintenanceLeadTimeDays(requestDate:string|undefined,createdAt:string,finishedAt?:string,now=new Date()){
  return leadTimeDays(requestDate||createdAt,finishedAt,now);
}

export function leadTimeTone(days:number):LeadTimeTone{
  if(days<=9)return "green";
  if(days<=15)return "yellow";
  if(days<=20)return "red";
  return "purple";
}
